"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _spinner = _interopRequireDefault(require("britive-design-system/core/components/spinner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpinnerContainer = function SpinnerContainer(_ref) {
  var open = _ref.open,
      size = _ref.size,
      message = _ref.message;
  return open && /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: size,
    message: message,
    overlay: true
  });
};

SpinnerContainer.propTypes = {
  open: _propTypes.default.bool,
  message: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'medium', 'large'])
};
var _default = SpinnerContainer;
exports.default = _default;